module.exports = __webpack_public_path__ + "User_Guide_NBDB_Fr_Oct_2026.pdf";